import { useEffect, useState } from "react";
import { Sparkles } from "lucide-react";
import { api } from "@/lib/api";

const fmt = (ms) => {
  const s = Math.max(0, Math.floor(ms / 1000));
  const parts = [[Math.floor(s / 86400), "d"], [Math.floor((s % 86400) / 3600), "h"], [Math.floor((s % 3600) / 60), "m"], [s % 60, "s"]];
  return parts.map(([v, u]) => `${String(v).padStart(2, "0")}${u}`).join(" ");
};

export const DropCountdown = ({ newCount = 0, compact = false }) => {
  const [target, setTarget] = useState(null);
  const [left, setLeft] = useState(0);

  useEffect(() => { api.get("/drops/next").then((r) => setTarget(new Date(r.data.next_drop_at))); }, []);
  useEffect(() => {
    if (!target) return;
    const tick = () => setLeft(target - new Date());
    tick();
    const t = setInterval(tick, 1000);
    return () => clearInterval(t);
  }, [target]);

  if (!target) return null;
  return (
    <div data-testid="drop-countdown"
      className={`flex flex-wrap items-center gap-x-4 gap-y-2 rounded-2xl bg-[#1E1B26] text-white ${compact ? "px-4 py-2.5" : "px-5 py-4"}`}>
      <span className="flex items-center gap-2 font-display font-semibold"><Sparkles className="h-4 w-4 text-[#FFC72C]" /> Weekly Style Drop</span>
      {newCount > 0 && <span className="rounded-full bg-[#FF5A79] px-2.5 py-0.5 text-xs font-bold" data-testid="drop-new-count">{newCount} new styles</span>}
      <span className="text-sm text-white/70">Next drop in</span>
      <span className="font-mono font-bold text-[#FFC72C]" data-testid="drop-countdown-timer">{fmt(left)}</span>
    </div>
  );
};
